var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPodsColor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a43a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 8.625,
    x2: 19.12,
    xlinkHref: "#a",
    y1: 19.385,
    y2: 16.641
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 7.457,
    x2: 17.777,
    xlinkHref: "#a",
    y1: 23.452,
    y2: 20.417
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 10.962,
    x2: 21.282,
    xlinkHref: "#a",
    y1: 21.115,
    y2: 18.08
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 5.119,
    x2: 15.615,
    xlinkHref: "#a",
    y1: 21.722,
    y2: 18.978
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.76 13.205c-.06.127.095.25.188.145 2.023-2.275 2.023-5.964 0-8.24-2.022-2.275-5.3-2.275-7.323 0-.096.108.052.256.176.184 1.951-1.14 4.412-.79 6.05 1.052 1.65 1.857 1.953 4.656.91 6.859z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.64 9.907c.064-.12-.08-.247-.175-.152a5.18 5.18 0 0 0 7.324 7.324c.095-.095-.033-.239-.152-.176a5.18 5.18 0 0 1 -6.997-6.996z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.113 14.566c-.12-.063-.247.08-.152.176a5.18 5.18 0 0 0 7.324-7.324c-.095-.095-.239.033-.176.152a5.18 5.18 0 0 1 -6.996 6.996z",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12.275 7.631c.124.072.272-.076.176-.183-2.022-2.276-5.301-2.276-7.324 0-2.022 2.275-2.022 5.963 0 8.239.094.105.249-.018.188-.146-1.043-2.203-.74-5.001.91-6.858 1.638-1.842 4.1-2.192 6.05-1.052z",
    fill: "url(#e)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPodsColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pods-color.2041e26ec903092185e7d3d4035918fe.svg";